__turbopack_context__.v({
  "iconExpand": "IconExpand-module__vmjBPW__iconExpand",
});
